<template>
	<div v-if="params.data" class="switch-renderer">
		<v-switch :model-value="value" :color="params.color || 'primary'" :disabled="disabled" density="compact" hide-details inset @update:model-value="onChange" />
	</div>
</template>

<script setup>
import { computed } from 'vue';

// Reports intent only: it never calls params.setValue(), so ag-Grid's cell-value-changed -> rowsChanged ->
// update:rowData path (a full row-array replacement) never fires. The owner of the data applies its rules
// and hands back fresh rows. Emits the very same { row, field, value } shape as TouchCardData's cell-change,
// so a zone can wire one handler to both the desktop grid and the mobile cards.
// cellRendererParams: { color?, disabledField?, onChange }
const props = defineProps({
	params: {
		type: Object,
		required: true,
	},
});

// Reads params.value on every render rather than snapshotting it on mount, so a re-dispatch is reflected.
const value = computed(() => Boolean(props.params.value));
const disabled = computed(() => (props.params.disabledField ? Boolean(props.params.data?.[props.params.disabledField]) : false));

function onChange(next) {
	props.params.onChange?.({ row: props.params.data, field: props.params.colDef?.field, value: Boolean(next) });
}
</script>

<style lang="scss">
.switch-renderer {
	display: flex;
	align-items: center;
	height: 100%;
}
</style>
